import { Link } from "react-router-dom";
import { EmailSvg, PhoneSvg } from "../svgFile";

function Footer() {


  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="footer-content">
                <div className="flogo mb-40">
                  <img src="/image/footer-logo.png" alt="" />
                  <p>
                    Our mission is to transform the logistics industry by making freight movements more efficient, accessible, and digitally empowered.
                  </p>
                </div>

                <div className="social-sec">
                  <h5>Connecting on Social Media</h5>
                  <div className="footer-icons d-flex gap-2 mt-4">
                    <Link to="#">
                      <img src="/image/instagram.svg" alt="Instagram" />
                    </Link>
                    <Link to="#">
                      <img src="/image/facebook-f.svg" alt="Facebook" />
                    </Link>
                    <Link to="#">
                      <img src="/image/twitter.svg" alt="Twitter" />
                    </Link>
                    <Link to="#">
                      <img src="/image/linkedin.svg" alt="LinkedIn" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-6">
              <div className="footer-item">
                <h5 className="mb-3">Quick Links</h5>
                <div className="footer-item-content">
                  <ul className="footer-links">
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        How It Works
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Services
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Carriers
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Testimonial
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        FAQs
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="footer-item ps-0 ps-lg-5">
                <h5 className="mb-3">Category</h5>
                <div className="footer-item-content">
                  <ul className="footer-links">
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Road Freight
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Ocean Freight
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Rail Freight
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Air Freight
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="footer-item">
                <h5 className="mb-3">Support</h5>
                <div className="footer-item-content">
                  <ul className="footer-links">
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Track Order
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Contact Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/terms-of-use">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Terms of Service
                      </Link>
                    </li>
                    <li>
                      <Link to="/privacy">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span>
                          <img src="/image/angle-right.svg" alt="" />
                        </span>
                        Cookie Policy
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-bottom-content d-flex flex-wrap justify-content-md-between justify-content-center align-items-center gap-3">


              <div className="d-flex flex-wrap  align-items-center gap-3 gap-lg-5 justify-content-center">
                <p className="text-16 text-white mb-0"> <span className="me-3">
                  <svg
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.353 2.5C18.054 2.911 20.978 5.831 21.393 9.532"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.353 6.04297C16.124 6.38697 17.508 7.77197 17.853 9.54297"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.0315 12.4724C15.0205 16.4604 15.9254 11.8467 18.4653 14.3848C20.9138 16.8328 22.3222 17.3232 19.2188 20.4247C18.8302 20.737 16.3613 24.4943 7.68447 15.8197C-0.993406 7.144 2.76157 4.67244 3.07394 4.28395C6.18377 1.17385 6.66682 2.58938 9.11539 5.03733C11.6541 7.5765 7.04254 8.48441 11.0315 12.4724Z"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                </span>1800-000-000</p>
                <p className="text-16 text-white mb-0 ms-md-3"> <span className="me-3"><EmailSvg /></span>support@komutan.com</p>
              </div>
              <div className="d-flex align-items-center gap-3 gap-lg-4">
                <img src="/image/stripe.png" alt="Stripe" />
                <img src="/image/paypal.png" alt="PayPal" />
              </div>
            </div>
          </div>
          <div className="footer-bottom mt-0">
            <div className="footer-bottom-content d-flex flex-wrap justify-content-md-between justify-content-center align-items-center gap-3">
              <p className="mb-0 text-white">
                © 2026 KOMUTAN. All Rights Reserved
              </p>
              <p className="mb-0 text-white">
                Powered by <a className="text-decoration-none text-white" href="https://www.braintechnosys.com/" target="_blank"> Brain Technosys</a>
              </p>
            </div>
          </div>
        </div>
      </footer>

    </>
  );
}

export default Footer;
